import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import WithReAuth from 'two-factor-prompt-lib/containers/WithReAuth';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const langKey = 'userPreferences.passkeys.deleteModal';
const DeletePasskeyModal = ({
  deletePasskey,
  deletePasskeyError,
  credentialId,
  email,
  hideModal,
  open
}) => {
  const ConfirmButton = () => /*#__PURE__*/_jsx(WithReAuth, {
    onSuccess: () => deletePasskey(credentialId),
    email: email,
    skipVerificationIfNotSet: true,
    children: /*#__PURE__*/_jsx(UIButton, {
      use: "danger",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${langKey}.confirm`
      })
    })
  });
  if (open) {
    return /*#__PURE__*/_jsx(UIConfirmModal, {
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${langKey}.title`
      }),
      description: /*#__PURE__*/_jsxs("div", {
        children: [deletePasskeyError && /*#__PURE__*/_jsx(UIAlert, {
          titleText: "Error",
          type: "danger",
          className: "m-bottom-2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${langKey}.error`
          })
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${langKey}.description`
        })]
      }),
      use: "danger",
      ConfirmButton: ConfirmButton,
      onConfirm: () => deletePasskey(credentialId),
      rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${langKey}.cancel`
      }),
      onReject: () => hideModal()
    });
  }
  return null;
};
export default DeletePasskeyModal;